module.exports = __webpack_public_path__ + "img/portal-download-token.611f859f.jpg";